/**
 * @generated SignedSource<<842971e054f7891451433b5f165765e2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type QuestionnaireType = "QMS" | "SURVEY_LAB";
import { FragmentRefs } from "relay-runtime";
export type QuestionnaireCriticalitySummaryFragment$data = {
  readonly criticals: number;
  readonly infos: number;
  readonly questionnaireType: QuestionnaireType;
  readonly useCaseName: string;
  readonly warnings: number;
  readonly " $fragmentType": "QuestionnaireCriticalitySummaryFragment";
};
export type QuestionnaireCriticalitySummaryFragment$key = {
  readonly " $data"?: QuestionnaireCriticalitySummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionnaireCriticalitySummaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuestionnaireCriticalitySummaryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useCaseName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "criticals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "warnings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "infos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionnaireType",
      "storageKey": null
    }
  ],
  "type": "QuestionnaireCriticalitySummaryOutput",
  "abstractKey": null
};

(node as any).hash = "289c26c247fe63a98b19914ebb22b0f1";

export default node;
